import { createContext, useContext, useEffect, useState } from "react";
import { db } from "../firebaseConfig";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useAuth } from "./AuthContext";
import toast from "react-hot-toast";

const CountsContext = createContext();

export const CountsProvider = ({ children }) => {
  const { user, loading } = useAuth(); // Get user and loading state
  const [counts, setCounts] = useState({
    inbox: 0,
    vendorRequests: 0,
    notifications: 0,
    complaints: 0,
  });

  useEffect(() => {
    if (loading) {
      // Wait until the authentication state is resolved
      return;
    }

    if (!user) {
      console.log("No user authenticated, setting counts to 0.");
      setCounts({
        inbox: 0,
        vendorRequests: 0,
        notifications: 0,
        complaints: 0,
      });
      return;
    }

    // Real-time listeners for each collection
    const collections = [
      { name: "inboxMessages", key: "inbox" },
      { name: "vendorApplications", key: "vendorRequests" },
      { name: "notifications", key: "notifications" },
      { name: "supportRequests", key: "complaints" },
    ];

    const unsubscribes = collections.map(({ name, key }) => {
      let q;
      if (name === "inboxMessages") {
        q = query(
          collection(db, name),
          where("recipientId", "==", user.uid)
        );
      } else if (name === "vendorApplications") {
        q = query(
          collection(db, name),
          where("userId", "==", user.uid)
        );
      } else if (name === "notifications") {
        q = query(
          collection(db, name),
          where("userId", "==", user.uid)
        );
      } else if (name === "supportRequests") {
        q = query(
          collection(db, name),
          where("userId", "==", user.uid)
        );
      }

      return onSnapshot(
        q,
        (snapshot) => {
          setCounts((prev) => ({ ...prev, [key]: snapshot.size }));
        },
        (error) => {
          console.error(`Error fetching ${name} count:`, error);
          setCounts((prev) => ({ ...prev, [key]: 0 }));
          toast.error(`Failed to fetch ${key} count: ${error.message}`);
        }
      );
    });

    return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
  }, [user, loading]); // Add loading as a dependency

  return (
    <CountsContext.Provider value={counts}>
      {children}
    </CountsContext.Provider>
  );
};

export const useCounts = () => useContext(CountsContext);